import styled from 'styled-components'

export default styled.div`
  background-color: white;
  padding: ${props => (props.withHeader ? 10 : 30)}px 30px 30px 30px;
  border: 1px solid ${props => (props.error ? '#fa4624' : '#acb3b9')};
  position: relative;
  text-align: justify;

  [data-tip] {
    cursor: pointer;
    text-decoration: underline;
    font-style: normal;
  }
`



// WEBPACK FOOTER //
// ./components/atoms/card.js